export default "__VITE_ASSET__BCJZTnUM__"